import $ from 'jquery';

// Tracks whether the resizing operation is in progress
let resizing = false;

// Set all .equal-height-element items to have a minimum height equal of the tallest one,
// scoped within the ancestor .equal-height-scope
function resizeEqualHeightElements() {

  if (!resizing) {
    
    window.requestAnimationFrame(function () {
      $('.equal-height-scope').each(function() {
        const $equalHeightElements = $(this).find(':not(".equal-height-scope") .equal-height-element');
    
        $equalHeightElements.css('min-height', '');
    
        const tallestHeight = $equalHeightElements
          .map(function() { return $(this).outerHeight()})
          .get()
          .reduce((a, b) => Math.max(a, b), 0);
    
        $equalHeightElements.css('min-height', tallestHeight + 'px');
      });

      resizing = false;
    });

    resizing = true;
  }
}

// Trigger resize equal height on ready and window load/resize
resizeEqualHeightElements();
$(window).on('load', resizeEqualHeightElements);
$(window).on('resize', resizeEqualHeightElements);